import type { WheelEvent } from 'react';

/** Blur number inputs on wheel so scroll does not change the value. */
export function inputBlurOnWheel(event: WheelEvent<HTMLInputElement>): void {
  event.currentTarget.blur();
}
